import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';

export class PhasrApplyActionPanelBaseDataProvider extends BaseWebComponentDataProvider {
}
